import Modal from "/WebInterface/new-ui/modules/modal.js";
import Tabs from "/WebInterface/new-ui/modules/tabs.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import TwoFactorAuthSetup from "/WebInterface/new-ui/modules/two-factor-auth/two-factor-auth.js";
import UserOptionsTemplate from "./template.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import store from "/WebInterface/new-ui/store/index.js";
import { validate } from "/WebInterface/new-ui/assets/js/utils/validate.js";
import {
  changePassword,
  changePhone,
  confirmQR,
} from "/WebInterface/new-ui/assets/js/utils/api/apis.js";

export const initUserOptions = () => {
  const twoFactorAuthSetup = new TwoFactorAuthSetup();

  const userOptionsCustomizations = () => {
    const canHideUserOptionHideDotItems = utils.getUserCustomizationValue(
      "HideUserOptionHideDotItems"
    );
    const canHideUserOptionHideCheckBoxColumn = utils.getUserCustomizationValue(
      "HideUserOptionHideCheckBoxColumn"
    );
    const canHideUserOptionHideFilterSection = utils.getUserCustomizationValue(
      "HideUserOptionHideFilterSection"
    );
    const canHideUserOptionAutoStartUpload = utils.getUserCustomizationValue(
      "HideUserOptionAutoStartUpload"
    );
    const canHideUserOptionChangePhone = utils.getUserCustomizationValue(
      "HideUserOptionChangePhone"
    );
    const canHideUserOptionChangePassword = utils.getUserCustomizationValue(
      "HideUserOptionChangePassword"
    );
    const canHideUserOptionGeneratePassword = utils.getUserCustomizationValue(
      "HideUserOptionGeneratePassword"
    );
    const enableUserOption2fa =
      utils.getUserCustomizationValue("UserOption2fa");
    const showOnlyTwoFactorAuthTab = utils.getUserCustomizationValue(
      "useroptions_only_twofactor_google_enrollment"
    );

    return {
      canHideUserOptionHideDotItems,
      canHideUserOptionHideCheckBoxColumn,
      canHideUserOptionHideFilterSection,
      canHideUserOptionAutoStartUpload,
      canHideUserOptionChangePhone,
      canHideUserOptionChangePassword,
      canHideUserOptionGeneratePassword,
      enableUserOption2fa,
      showOnlyTwoFactorAuthTab,
    };
  };

  const customizations = userOptionsCustomizations();
  const userPrivOptions = store?.userInfo?.user_priv_options;

  const hasChangePasswordPermission = userPrivOptions.includes("(SITE_PASS)");

  // user option modal
  const dialog = new Modal({
    body: UserOptionsTemplate({
      ...customizations,
      hasChangePasswordPermission,
    }),
    minWidth: "780px",
    extraClasses: ["user-options-dialog"],
    title: "User Options",
    onBeforeHide: () => {
      twoFactorAuthSetup.hide();

      const tabs = _$(dialog.root).find(".tab-pane").sel();

      const tempUserOptions = {};

      tabs.forEach(({ id }) => {
        const inputs = _$(`#${id}`).find("input").sel();
        tempUserOptions[id] = {};

        inputs.forEach((input) => {
          let value = input.value;
          if (input.type === "checkbox") value = input.checked;
          tempUserOptions[id][input.id] = value;
        });
      });

      tempUserOptions.activeTabIndex = tab.getIndex();

      let isGeneratePasswordSectionOpen = true;
      if (_$("#userOptionsGeneratePassword").hasClass("is-hidden"))
        isGeneratePasswordSectionOpen = false;

      tempUserOptions.isGeneratePasswordSectionOpen =
        isGeneratePasswordSectionOpen;

      store.dispatch("setUserOptions", tempUserOptions);
    },
    onAfterShow: () => {
      twoFactorAuthSetup.renderTemplate({
        templateContainer: "#setup2FactorAuth",
        templateValues: {},
        onAfterTimeout: () => {
          dialog.update({
            buttons: [],
          });
        },
      });

      twoFactorAuthSetup.addSetupButtonListener(() => {
        const shouldShowQR = window.confirm(
          "Are you ready to scan the QR code using the Authenticator App?"
        );
        if (!shouldShowQR) return;
        showQR();
      });
    },
  });

  const showQR = async () => {
    twoFactorAuthSetup.show();

    dialog.update({
      // Footer buttons for two factor auth tab
      buttons: [
        {
          label: "cancel",
          classes: ["secondary-button", "mr-3"],
          onClick: async () => {
            twoFactorAuthSetup.hide();
            dialog.update({
              buttons: [],
            });
          },
        },
        {
          label: "confirm",
          classes: ["primary-button", "mr-3"],
          onClick: async () => {
            try {
              const response = await confirmQR({
                qrid: twoFactorAuthSetup.UNIQUE_QR_ID,
              });
              growl("", response, 5000, false);

              twoFactorAuthSetup.hide();
              dialog.hide(true);
            } catch (error) {
              growl("", error, 5000, true);
            }
          },
        },
      ],
    });
  };

  // rendering value for user options(preference tab) from localStorage
  const userOptions = JSON.parse(localStorage.getItem("userOptions")) || {};
  const modalBody = dialog.modal.body;

  const options = Object.keys(userOptions);
  options.forEach((opt) => {
    const elem = _$(modalBody).find(`[name=${opt}]`, true);

    if (elem?.type === "checkbox") {
      elem.checked = true;
    }
  });

  // rendering value for user options from store
  const { userOptions: userOptionsStore } = store;
  const parentProperties = Object.keys(userOptionsStore);

  parentProperties.forEach((key) => {
    const option = userOptionsStore[key];
    const childrenProperties = Object.entries(option);

    if (childrenProperties.length > 0) {
      for (const [key, value] of childrenProperties) {
        const input = _$(`#${key}`).el();
        if (!input) return;
        if (input.type === "checkbox") {
          input.checked = value;
        } else {
          input.value = value || "";
        }
      }
    }
  });

  // forms in modal tab

  const changePasswordForm = _$("#userOptionsChangePasswordForm"); // tab 2 form

  const userOptionGeneratedPasswordWrapper = _$("#userOptionsGeneratePassword");

  if (userOptionGeneratedPasswordWrapper.el()) {
    // "use this generated password" logic
    const generatedPasswordInput = userOptionGeneratedPasswordWrapper.find(
      '[name="generatedPassword"]',
      true
    );
    const newPasswordInput = changePasswordForm.find(
      '[name="new_password1"]',
      true
    );
    const useThisPasswordButton = userOptionGeneratedPasswordWrapper.find(
      ".use-this",
      true
    );
    const cancelGeneratePasswordButton = _$(
      "#userOptionsGeneratePassword"
    ).find(".cancel-generate-password", true);

    cancelGeneratePasswordButton.addEventListener("click", () => {
      userOptionGeneratedPasswordWrapper.addClass("is-hidden");
    });

    useThisPasswordButton.addEventListener("click", () => {
      newPasswordInput.value = generatedPasswordInput.value;
    });

    if (userOptionsStore.isGeneratePasswordSectionOpen) {
      userOptionGeneratedPasswordWrapper.removeClass("is-hidden");
    }
  }

  // initializing tabs
  const tab = new Tabs({
    el: document.getElementById("userOptionsTab"),
    // updating footer buttons on tab change
    onTabChange: (tabName) => {
      if (twoFactorAuthSetup.QRTimer) clearInterval(twoFactorAuthSetup.QRTimer);

      switch (tabName) {
        case "tab1":
          const preferenceForm = _$("#userOptionsPreferenceForm");

          dialog.update({
            // Footer buttons for preferenceForm
            buttons: [
              {
                label: "save",
                close: true,
                classes: ["primary-button", "mr-3"],
                onClick: () => {
                  const preferenceData = utils.serializeInputs(
                    preferenceForm.el()
                  );
                  localStorage.setItem(
                    "userOptions",
                    JSON.stringify(preferenceData)
                  );

                  // hide filter section
                  const filterInputContainer = _$(
                    ".filter-sorting-section"
                  ).find(".filter-input-wrapper", true);
                  const searchAndFilterDivider = _$(
                    ".filter-sorting-section"
                  ).find("#searchAndFilterDivider");

                  if (filterInputContainer && searchAndFilterDivider) {
                    if (preferenceData.hideFilterSection) {
                      _$(filterInputContainer).addClass("is-hidden");
                      searchAndFilterDivider.addClass("is-hidden");
                    } else {
                      _$(filterInputContainer).removeClass("is-hidden");
                      searchAndFilterDivider.removeClass("is-hidden");
                    }
                  }

                  // hide dot items
                  if (
                    (preferenceData.hideDotItems &&
                      !userOptions.hideDotItems) ||
                    (!preferenceData.hideDotItems && userOptions.hideDotItems)
                  ) {
                    store.dispatch("refreshListing");
                    return;
                  }

                  // hide checkbox column
                  if (
                    preferenceData.hideCheckboxColumn &&
                    !userOptions.hideCheckboxColumn
                  ) {
                    store.dispatch("handleSelectFiles", "uncheckAll");

                    const allCheckboxInput = _$(
                      "#dashboard-files-section .table-tr .table-td.check-td,#dashboard-files-section #checkTh"
                    ).sel();
                    allCheckboxInput.forEach((elem) => {
                      const checkboxInput = _$(elem).find(
                        "input[type = 'checkbox']",
                        true
                      );
                      checkboxInput.checked = false;
                      elem.classList.add("is-hidden");
                    });
                  } else if (
                    !preferenceData.hideCheckboxColumn &&
                    userOptions.hideCheckboxColumn
                  ) {
                    const allCheckboxInput = _$(
                      "#dashboard-files-section .table-tr .table-td.check-td,#dashboard-files-section #checkTh"
                    ).sel();
                    allCheckboxInput.forEach((elem) => {
                      elem.classList.remove("is-hidden");
                    });
                  }
                },
              },
            ],
          });
          break;
        case "tab2":
          const buttons = [
            {
              label: "generateRandomPassword",
              classes: ["secondary-button", "mr-3"],
              onClick: () => {
                _$("#userOptionsGeneratePassword").removeClass("is-hidden");

                const passwordRule = {
                  random_password_length:
                    store?.userInfo.random_password_length,
                  min_password_numbers: store?.userInfo.min_password_numbers,
                  min_password_lowers: store?.userInfo.min_password_lowers,
                  min_password_uppers: store?.userInfo.min_password_uppers,
                  min_password_specials: store?.userInfo.min_password_specials,
                };

                const generatedPassword =
                  utils.generatePasswordBasedOnRules(passwordRule);
                const generatedPasswordInput = _$(
                  "#userOptionsGeneratePassword"
                ).find('[name="generatedPassword"]', true);
                generatedPasswordInput.value = generatedPassword;
              },
            },
            {
              label: "changePassword",
              classes: ["primary-button", "mr-3"],
              onClick: async () => {
                const validateFields = validate(changePasswordForm.el(), false);
                if (validateFields.length === 0) {
                  const changedPasswordData = utils.serializeInputs(
                    changePasswordForm.el()
                  );
                  try {
                    const result = await changePassword(changedPasswordData);
                    const { response } = result.commandResult;
                    growl("", response, 5000, response !== "success");
                  } catch (error) {
                    console.log(error);
                  }
                }
              },
            },
          ];

          if (customizations.canHideUserOptionGeneratePassword) {
            buttons.shift();
          }
          dialog.update({
            // Footer buttons for changePasswordForm
            buttons,
          });
          break;
        case "tab3":
          const phoneNumberForm = _$("#userOptionsPhoneNumberForm").el();

          dialog.update({
            // Footer buttons for phoneNoForm
            buttons: [
              {
                label: "save",
                classes: ["primary-button", "mr-3"],
                onClick: async () => {
                  const validateFields = validate(phoneNumberForm, false);

                  if (validateFields.length === 0) {
                    const phoneNumberFormData =
                      utils.serializeInputs(phoneNumberForm);

                    try {
                      const result = await changePhone(phoneNumberFormData);
                      growl("", result, 5000, false);
                    } catch (error) {
                      console.log(error);
                    }
                  }
                },
              },
            ],
          });
          break;
        case "tab4":
          if (twoFactorAuthSetup.isQRCodeOpen) {
            showQR();
            return;
          }

          _$("#twoFactorAuthQRContainer").addClass("is-hidden");
          _$("#setup2FactorAuthButton").removeClass("is-hidden");

          dialog.update({
            // Footer buttons for 2fa
            buttons: [],
          });
          break;
        default:
          break;
      }
    },
  });

  if (userOptionsStore.activeTabIndex) {
    tab.setIndex(userOptionsStore.activeTabIndex);
  }
};
